module.exports = __webpack_public_path__ + "img/xml.ff5af8be.svg";